import { render, staticRenderFns } from "./forbidden.vue?vue&type=template&id=750a460a&scoped=true&"
import script from "./forbidden.vue?vue&type=script&lang=ts&"
export * from "./forbidden.vue?vue&type=script&lang=ts&"
import style0 from "./forbidden.vue?vue&type=style&index=0&id=750a460a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750a460a",
  null
  
)

export default component.exports